// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable property-disallowed-list -- DS general definition */
:root {
    /* Aliases */
    /* Shallow */
    --ds-shadow-shallow-y-axis: var(--ds-xs);
    --ds-shadow-shallow-blur: var(--ds-sm);
    --ds-shadow-shallow-color: var(--ds-color-grey-90);
    --ds-shadow-shallow: 0px var(--ds-shadow-shallow-y-axis)
        var(--ds-shadow-shallow-blur) 0px var(--ds-shadow-shallow-color);
    /* Mid */
    --ds-shadow-mid-y-axis: var(--ds-xs);
    --ds-shadow-mid-blur: var(--ds-9x);
    --ds-shadow-mid-color: var(--ds-color-grey-indigo-100);
    --ds-shadow-mid: 0px var(--ds-shadow-mid-y-axis) var(--ds-shadow-mid-blur)
        0px var(--ds-shadow-mid-color);
    /* Deep */
    --ds-shadow-deep-y-axis: var(--ds-9x);
    --ds-shadow-deep-blur: var(--ds-3xl);
    --ds-shadow-deep-color: var(--ds-color-grey-100);
    --ds-shadow-deep: 0px var(--ds-shadow-deep-y-axis)
        var(--ds-shadow-deep-blur) 0px var(--ds-shadow-deep-color);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
